// The workspace sidebar's own search: what its box holds and its list
// follows, apart from the board's (lib/workspaceSearch.js), which clicks on
// the board narrow and the dock lists. Either can be handed to the other.
import { useSyncExternalStore } from "react";

let text = "";
const subscribers = new Set();

export function setSidebarSearch(next) {
  const value = typeof next === "function" ? next(text) : next;
  if (value === text) return;
  text = String(value ?? "");
  for (const fn of subscribers) fn();
}

const subscribe = (fn) => {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
};
const read = () => text;

export function useSidebarSearch() {
  return [useSyncExternalStore(subscribe, read, read), setSidebarSearch];
}
